import { createApiClient, getLocalTimestamp, getTimezoneOffsetString } from '../../../../../api/apiClient';

export interface LatestUpdateDateResponse {
  latestUpdateDate?: string | null;
}

interface LatestUpdateEnvelope {
  data?: LatestUpdateDateResponse;
  latestUpdateDate?: string | null;
}

export function normalizeLatestUpdateDateResponse(
  response: LatestUpdateEnvelope | LatestUpdateDateResponse | null | undefined
): LatestUpdateDateResponse {
  const nestedLatestUpdateDate =
    response && 'data' in response ? response.data?.latestUpdateDate : undefined;
  const latestUpdateDate = nestedLatestUpdateDate ?? response?.latestUpdateDate ?? null;

  return {
    latestUpdateDate,
  };
}

export async function fetchLatestUpdateDate(): Promise<LatestUpdateDateResponse> {
  const api = createApiClient();
  const clientTimestamp = getLocalTimestamp();
  const clientTimezone = getTimezoneOffsetString();

  const response = await api.get<LatestUpdateEnvelope | LatestUpdateDateResponse>(
    '/ontime-dispatch/latest-update-date',
    { params: { clientTimestamp, clientTimezone } }
  );

  return normalizeLatestUpdateDateResponse(response.data);
}